<template>
  <b-modal id="modal-cash-report" hide-footer ok-title="Tutup" size="lg" class="custom__modal">
    <template #modal-header>
      <div
        v-if="showBackButton"
        class="text-primary fw-bold-600 pt-25 cursor-pointer"
        @click="goBack(backTarget)"
      >
        <feather-icon size="16" class="text-primary fw-bold-800" icon="ArrowLeftIcon" />
        Kembali
      </div>

      <div :class="['mx-auto', showBackButton ? 'pr-4' : '']">
        <div class="size20 fw-bold-600 text-dark" style="margin-left: 100px;">{{ headerTitle }}</div>
      </div>
      <button
        type="button"
        class="btn btn-outline-secondary py-1 bg-secondary text-white"
        :disabled="isLoading"
        @click="exportToPDF"
      >
        <template v-if="isLoading">
          <b-spinner small type="border" class="mr-2"></b-spinner>
          Loading...
        </template>
        <template v-else>
          Export to PDF
        </template>
      </button>
    </template>
    <div class="p-2" v-if="isReturSelling">
      <retur-selling :items="detailResultList.order_returned_list" />
    </div>
    <div class="p-2" v-if="isReturPurchasing">
      <retur-purchasing :items="detailResultList.incoming_stock_returned_list" />
    </div>
    <div class="p-2" v-if="isPiutangPayments">
      <piutang-payments :items="detailResultList.piutang_payment_list" />
    </div>
    <div class="p-2" v-if="isUtangPayments">
      <utang-payments :items="detailResultList.utang_payment_list" />
    </div>
    <div class="p-2" v-if="isTopupDeposit">
      <topup-deposit :items="detailResultList.topup_deposit_payment_list" />
    </div>
    <div class="p-2" v-if="isWithdrawDeposit">
      <withdraw-deposit :items="detailResultList.withdraw_deposit_payment_list" />
    </div>
    <div class="p-2" v-if="isAdditionalCash">
      <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 12px">
        <h5 class="size14 fw-bold-700 mb-0">Cash Tambahan</h5>
        <h5 class="size14 fw-bold-700 mb-0">Deskripsi</h5>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-2" style="margin-bottom: 6px"
        v-for="(item, index) in detailResultList.additional_list" :key="index">
        <h5 class="size14 fw-bold-600 mb-0">
          {{ formatToRupiah(item.amount) }}
        </h5>
        <h5 class="size14 fw-bold-600 mb-0">
          {{ item.description }}
        </h5>
      </div>
      <b-form-group class="custom__form--input">
        <label for="v-closing_cash">Total Cash Tambahan</label>
        <b-input-group prepend="Rp">
          <b-form-input id="v-closing_cash" v-model="detailResultList.additional_cash" class="custom__input" type="text"
            disabled />
        </b-input-group>
      </b-form-group>
    </div>
    <div class="p-2" v-if="isCashChange">
      <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 12px">
        <h5 class="size14 fw-bold-700 mb-0">No Invoice</h5>
        <h5 class="size14 fw-bold-700 mb-0">Kembalian</h5>
      </div>
      <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 6px"
        v-for="item in detailResultList.cash_change_list" :key="item.uuid">
        <router-link class="text-primary" :to="'invoice/' + item.uuid" target="_blank">
          {{ item.invoice_number }}
        </router-link>
        <h5 class="size14 fw-bold-600 mb-0">
          {{ formatToRupiah(item.cash_change) }}
        </h5>
      </div>
    </div>
    <div class="p-2" v-if="isReturList">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">No. Invoice</th>
            <th scope="col">Kuantiti</th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="retur in detailResultList.order_returned_list" :key="retur.uuid">
            <td>{{ retur.invoice_number }}</td>
            <td>{{ retur.qty }}</td>
            <td>{{ formatToRupiah(retur.total) }}</td>
          </tr>
        </tbody>
        <tbody v-if="detailResultList.order_returned_list && detailResultList.order_returned_list.length === 0">
          <tr>
            <td
              colspan="4"
              class="text-center"
            >
              Data kosong.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="p-2" v-if="isCanceledOrder">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">No. Invoice</th>
            <th scope="col">Kuantiti</th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="canceledOrder in detailResultList.order_canceled_list" :key="canceledOrder.uuid">
            <td>
              <router-link class="text-primary" :to="'invoice/' + canceledOrder.uuid" target="_blank">
                {{ canceledOrder.invoice_number }}
              </router-link>
            </td>
            <td>{{ canceledOrder.qty }}</td>
            <td>{{ formatToRupiah(canceledOrder.total) }}</td>
          </tr>
        </tbody>
        <tbody v-if="detailResultList.order_canceled_list && detailResultList.order_canceled_list.length === 0">
          <tr>
            <td
              colspan="4"
              class="text-center"
            >
              Data kosong.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-row class="px-2 pt-2" v-if="shouldShowDefaultView">
      <b-col cols="12">
        <b-form-group class="custom__form--input">
          <label>Nama Kasir</label>
          <div class="custom__input px-1 py-1">
            {{ detailResult.operator_name }}
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group class="custom__form--input">
          <label>Waktu Buka</label>
          <div class="custom__input px-1 py-1">
            {{ detailResult.opening_time }}
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group class="custom__form--input">
          <label>Waktu Tutup</label>
          <div class="custom__input px-1 py-1">
            {{ detailResult.closing_time }}
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group class="custom__form--input">
          <label>Jumlah Invoice</label>
          <div class="custom__input px-1 py-1">
            {{ totalCountInvoice }}
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group class="custom__form--input">
          <label>Jumlah Item Terjual</label>
          <div class="custom__input px-1 py-1">
            {{ totalCountProductSold }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Cash In and Cash Out -->
    <cash-in-cash-out v-if="shouldShowDefaultView" :cashOut="cashOut" :formPayload="formPayload" :cashIn="cashIn" :detailResultList="detailResultList" :openCashModal="openCashModal" :goToSellingDetail="goToSellingDetail" :goToCashOutDetail="goToCashOutDetail" :goToStockLocationSku="goToStockLocationSku" :goToStockSupplier="goToStockSupplier" />
    <!-- End Cash In and Cash Out -->

    <!-- Transaksi dan Retur Penjualan -->
    <b-row class="px-2" v-if="shouldShowDefaultView">
      <b-col cols="8" lg="6" class="lg-mb-2 mb-2">
        <h3 class="font-weight-bolder text-dark">Transaksi dan Retur Penjualan</h3>
        <hr class="mb-0" style="border-color: rgb(107 110 107);">
      </b-col>
      <b-col cols="4" lg="6"></b-col>

      <b-col cols="12" lg="6" md="6">
        <b-row>
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Tunai</label>
              <div class="custom__input px-1 py-1">
                {{ paymentCounts.tunai }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Total Nominal Tunai</label>
              <div class="custom__input px-1 py-1">
                {{ summaryAmounts.cash | formatAmount }}
              </div>
            </b-form-group>
          </b-col>
          
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Transfer Bank</label>
              <div class="custom__input px-1 py-1">
                {{ paymentCounts.transfer }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Total Nominal Transfer Bank</label>
              <div class="custom__input px-1 py-1">
                {{ summaryAmounts.transfer | formatAmount }}
              </div>
            </b-form-group>
          </b-col>

          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Kredit atau Debit</label>
              <div class="custom__input px-1 py-1">
                {{ paymentCounts.kartu }}
              </div>
            </b-form-group>
          </b-col>
          
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Total Nominal Kredit atau Debit</label>
              <div class="custom__input px-1 py-1">
                {{ summaryAmounts.card | formatAmount }}
              </div>
            </b-form-group>
          </b-col>

          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Piutang</label>
              <div class="custom__input px-1 py-1">
                {{ paymentCounts.piutang }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Total Nominal <br /> Piutang</label>
              <div class="custom__input px-1 py-1">
                {{ summaryAmounts.piutang | formatAmount }}
              </div>
            </b-form-group>
          </b-col>

          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Customer Point</label>
              <div class="custom__input px-1 py-1">
                {{ paymentCounts.point }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Total Nominal <br /> Customer Point</label>
              <div class="custom__input px-1 py-1">
                {{ summaryAmounts.point | formatAmount }}
              </div>
            </b-form-group>
          </b-col>

          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Giro</label>
              <div class="custom__input px-1 py-1">
                {{ paymentCounts.giro }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Total Nominal Giro</label>
              <div class="custom__input px-1 py-1">
                {{ summaryAmounts.giro | formatAmount }}
              </div>
            </b-form-group>
          </b-col>

          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Deposit</label>
              <div class="custom__input px-1 py-1">
                {{ paymentCounts.deposit }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Total Nominal Deposit</label>
              <div class="custom__input px-1 py-1">
                {{ summaryAmounts.wallet | formatAmount }}
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12" lg="6" md="6">
        <b-row style="margin-top: -20px;">
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Retur Tunai</label>
              <div class="custom__input px-1 py-1">
                {{ paymentCounts.cashReturn }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Total Nominal Retur Tunai</label>
              <div class="custom__input px-1 py-1">
                {{ summaryAmounts.cashReturn | formatAmount }}
              </div>
            </b-form-group>
          </b-col>

          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Retur Transfer Bank</label>
              <div class="custom__input px-1 py-1">
                {{ paymentCounts.transferReturn }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Total Nominal Retur Transfer Bank</label>
              <div class="custom__input px-1 py-1">
                {{ summaryAmounts.transferReturn | formatAmount }}
              </div>
            </b-form-group>
          </b-col>

          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Retur Deposit</label>
              <div class="custom__input px-1 py-1">
                {{ paymentCounts.walletReturn }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Total Nominal Retur Deposit</label>
              <div class="custom__input px-1 py-1">
                {{ summaryAmounts.walletReturn | formatAmount }}
              </div>
            </b-form-group>
          </b-col>

          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Retur Piutang</label>
              <div class="custom__input px-1 py-1">
                {{ paymentCounts.piutangReturn }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Total Nominal Retur Piutang</label>
              <div class="custom__input px-1 py-1">
                {{ summaryAmounts.piutangReturn | formatAmount }}
              </div>
            </b-form-group>
          </b-col>

          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Retur Customer Point</label>
              <div class="custom__input px-1 py-1">
                {{ paymentCounts.pointReturn }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6" lg="6" class="align-self-end">
            <b-form-group class="custom__form--input">
              <label>Total Nominal Retur Customer Point</label>
              <div class="custom__input px-1 py-1">
                {{ summaryAmounts.pointReturn | formatAmount }}
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="8" lg="6" class="lg-mb-2 mb-1">
        <h3 class="font-weight-bolder text-dark">Mutasi Penjualan Hari ini</h3>
        <hr class="mb-0" style="border-color: rgb(107 110 107);">
      </b-col>
      <b-col cols="4" lg="6"></b-col>

      <b-col cols="12">
        <b-form-group class="custom__form--input">
          <label>Total Nominal Tunai</label>
          <div class="custom__input px-1 py-1">
            {{ totalNominalTunai | formatAmount }}
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group class="custom__form--input">
          <label>Total Nominal Transfer Bank</label>
          <div class="custom__input px-1 py-1">
            {{ totalNominalTransfer | formatAmount }}
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group class="custom__form--input">
          <label>Total Nominal Deposit</label>
          <div class="custom__input px-1 py-1">
            {{ totalNominalDeposit | formatAmount }}
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group class="custom__form--input">
          <label>Total Nominal Giro</label>
          <div class="custom__input px-1 py-1">
            {{ totalNominalGiro | formatAmount }}
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group class="custom__form--input">
          <label>Total Nominal Kredit/Debit</label>
          <div class="custom__input px-1 py-1">
            {{ totalNominalCard | formatAmount }}
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group class="custom__form--input">
          <label>Total Nominal Piutang</label>
          <div class="custom__input px-1 py-1">
            {{ totalNominalPiutang | formatAmount }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group class="custom__form--input">
          <label>Total Nominal Customer Point</label>
          <div class="custom__input px-1 py-1">
            {{ totalNominalPoint | formatPoint }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group class="custom__form--input">
          <label>Total Nominal Mutasi</label>
          <div class="custom__input px-1 py-1">
            {{ totalAllNominalMutations | formatAmount }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  BRow,
  BCol,
  BContainer,
  BTable,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BInputGroup,
  BIconTelephoneMinusFill,
  BLink,
  BSpinner,
} from "bootstrap-vue";
import {
  checkPermission,
  successNotification,
  errorNotification,
  preformatFloat,
} from "@/auth/utils";

import ReturSelling from './ReturSelling.vue';
import ReturPurchasing from './ReturPurchasing.vue';
import PiutangPayments from './PiutangPayments.vue';
import UtangPayments from './UtangPayments.vue';
import TopupDeposit from "./TopupDeposit.vue";
import WithdrawDeposit from "./WithdrawDeposit.vue";

import moment from "moment";
import { f } from "vue2-timepicker";
import CashInCashOut from './CashInCashOut.vue';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  components: {
    BButton,
    BSpinner,
    BModal,
    BRow,
    BCol,
    BContainer,
    BTable,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormCheckbox,
    BLink,
    ReturSelling,
    ReturPurchasing,
    PiutangPayments,
    UtangPayments,
    TopupDeposit,
    WithdrawDeposit,
    CashInCashOut,
  },
  setup() {
    return {
      checkPermission,
      successNotification,
      errorNotification,
      preformatFloat,
    };
  },
  computed: {
    showBackButton() {
      return this.isAdditionalCash || this.isReturList || this.isCashChange || this.isCanceledOrder || this.isReturSelling || this.isReturPurchasing || this.isPiutangPayments || this.isUtangPayments || this.isTopupDeposit || this.isWithdrawDeposit;
    },
    backTarget() {
      if (this.isAdditionalCash) return 'additional';
      if (this.isReturList) return 'retur';
      if (this.isCanceledOrder) return 'canceledOrder';
      if (this.isReturSelling) return 'retur_selling';
      if (this.isReturPurchasing) return 'retur_purchasing';
      if (this.isPiutangPayments) return 'piutang_payments';
      if (this.isUtangPayments) return 'utang_payments';
      if (this.isTopupDeposit) return 'topup_deposit';
      if (this.isWithdrawDeposit) return 'withdraw_deposit';
      return 'cash';
    },
    headerTitle() {
      if (this.isAdditionalCash) return 'Detail Cash Tambahan';
      if (this.isCashChange) return 'Kembalian';
      if (this.isReturList) return 'List Jumlah Retur';
      if (this.isReturSelling) return 'List Jumlah Retur Penjualan';
      if (this.isCanceledOrder) return 'List Transaksi Dibatalkan';
      if (this.isReturPurchasing) return 'List Jumlah Retur Pembelian';
      if (this.isPiutangPayments) return 'List Pembayaran Piutang';
      if (this.isUtangPayments) return 'List Pembayaran Utang';
      if (this.isTopupDeposit) return 'List Topup Deposit';
      if (this.isWithdrawDeposit) return 'List Withdraw Deposit';
      return 'Kas Harian';
    },
    shouldShowDefaultView() {
      return !this.isAdditionalCash && !this.isCashChange && !this.isReturList && !this.isCanceledOrder && !this.isReturSelling && !this.isReturPurchasing && !this.isPiutangPayments && !this.isUtangPayments && !this.isTopupDeposit && !this.isWithdrawDeposit;
    },
    totalAmount() {
      const amounts = [
        this.cashIn.order_success_amount,
        this.detailResult.transfer_amount,
        this.detailResult.card_amount,
        this.detailResult.giro_amount,
        this.detailResult.wallet_amount,
        this.detailResult.piutang_amount
      ];

      return amounts
        .map(val => parseFloat((val + '').replace(/\./g, '')) || 0)
        .reduce((sum, val) => sum + val, 0);
    },
    totalCount() {
      const counts = [
        this.detailResult.cash_count,
        this.detailResult.transfer_count,
        this.detailResult.card_count,
        this.detailResult.giro_count,
        this.detailResult.wallet_count,
        this.detailResult.piutang_count,
        this.detailResult.piutang_count
      ];

      return counts
        .map(val => parseFloat((val + '').replace(/\./g, '')) || 0)
        .reduce((sum, val) => sum + val, 0);
    },
    totalNominalTransaksi() {
      const order_success_amount = parseFloat(this.cashIn?.order_success_amount?.replaceAll('.', '') || 0);
      const order_canceled_amount = parseFloat(this.cashOut?.order_canceled_amount?.replaceAll('.', '') || 0);
      const order_return_amount = parseFloat(this.cashOut?.order_return_amount?.replaceAll('.', '') || 0);

      return order_success_amount - (order_canceled_amount + order_return_amount)
    },
    totalCountInvoice() {
      const order_success_count = parseFloat(this.detailResult?.order_success_count || 0);
      const order_canceled_count = parseFloat(this.detailResult?.order_canceled_count || 0);
      // const order_returned_count = parseFloat(this.detailResult?.order_returned_count || 0);

      return Math.max(order_success_count - (order_canceled_count), 0);
    },
    totalCountProductSold() {
      const product_count = parseFloat(this.detailResult?.product_count || 0);
      const product_return_count = parseFloat(this.detailResult?.product_return_count || 0);

      return Math.max(product_count - product_return_count, 0);
    },
    paymentCounts() {
      const d = this.detailResult?.order_summary_report?.count || {};

      const tunai = (d?.cash_count || 0);
      const transfer = (d?.transfer_count || 0);
      const kartu = (d?.card_count || 0);
      const giro = (d?.giro_count || 0);
      const deposit = (d?.wallet_count || 0);
      const piutang = (d?.piutang_count || 0);
      const point = (d?.point_count || 0);
      const cashReturn = (d?.cash_return_count || 0);
      const transferReturn = (d?.transfer_return_count || 0);
      const walletReturn = (d?.wallet_return_count || 0);
      const piutangReturn = (d?.piutang_return_count || 0);
      const pointReturn = (d?.point_return_count || 0);

      const total = tunai + transfer + kartu + giro + deposit + piutang + point;

      return {
        tunai,
        transfer,
        kartu,
        giro,
        deposit,
        piutang,
        cashReturn,
        transferReturn,
        walletReturn,
        piutangReturn,
        point,
        pointReturn,
        total
      };
    },
    // 
    summaryAmounts() {
      const amount = this.detailResult?.order_summary_report?.amount || {};
      return {
        cash: amount.cash_amount || 0,
        transfer: amount.transfer_amount || 0,
        giro: amount.giro_amount || 0,
        card: amount.card_amount || 0,
        wallet: amount.wallet_amount || 0,
        piutang: amount.piutang_amount || 0,
        point: amount.point_amount || 0,
        cashReturn: amount.cash_return_amount || 0,
        transferReturn: amount.transfer_return_amount || 0,
        walletReturn: amount.wallet_return_amount || 0,
        piutangReturn: amount.piutang_return_amount || 0,
        pointReturn: amount.point_return_amount || 0
      };
    },
    // Section Mutation
    totalNominalTunai() {
      return this.summaryAmounts.cash - this.summaryAmounts.cashReturn;
    },
    totalNominalTransfer() {
      return this.summaryAmounts.transfer - this.summaryAmounts.transferReturn;
    },
    totalNominalDeposit() {
      return this.summaryAmounts.wallet - this.summaryAmounts.walletReturn;
    },
    totalNominalGiro() {
      return this.detailResult.giro_amount;
    },
    totalNominalCard() {
      return this.detailResult.card_amount;
    },
    totalNominalPiutang() {
      return this.summaryAmounts.piutang - this.summaryAmounts.piutangReturn;
    },
    totalNominalPoint() {
      return this.summaryAmounts.point - this.summaryAmounts.pointReturn;
    },
    totalAllNominalMutations() {
      return (
        this.totalNominalTunai +
        this.totalNominalTransfer +
        this.totalNominalDeposit +
        this.totalNominalGiro +
        this.totalNominalCard +
        this.totalNominalPiutang
      );
    }
  },
  data() {
    const newData = new Date();
    const momentDate = moment(newData);
    const days = [
      "Minggu",
      "Senin",
      "Selasa",
      "Rabu",
      "Kamis",
      "Jumat",
      "Sabtu",
    ];
    const months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];
    const formattedDate = `${days[momentDate.day()]}, ${momentDate.format(
      "DD"
    )} ${months[momentDate.month()]} ${momentDate.format("YYYY HH:mm")}`;

    return {
      moment,
      isLoading: false,
      user: JSON.parse(localStorage.getItem("userData")),
      date: formattedDate,
      formPayload: {
        closing_cash: 0,
      },
      detailResultList: {},
      isAdditionalCash: false,
      isReturList: false,
      isCashChange: false,
      isCanceledOrder: false,
      isReturSelling: false,
      isReturPurchasing: false,
      isPiutangPayments: false,
      isUtangPayments: false,
      isTopupDeposit: false,
      isWithdrawDeposit: false,
      cashIn: Object,
      cashOut: Object,
    };
  },
  props: {
    getData: {
      type: Function,
    },
    detailResult: {
      type: Object,
    },
  },
  watch: {
    detailResult(result) {
      this.detailResultList = result;
      this.cashIn = result?.cash_details?.cash_in;
      this.cashOut = result?.cash_details?.cash_out;
      this.setRupiah()
    },
  },
  methods: {
    setRupiah() {
      const format = (value) => this.formatRupiah((value ?? 0).toString().replace('-', ''));

      // Format main cash fields
      this.detailResultList.opening_cash = format(this.detailResultList?.opening_cash);
      this.detailResultList.additional_cash = format(this.detailResultList?.additional_cash);
      this.formPayload.closing_cash = this.formatToRupiah(this.detailResultList?.cash_summary);

      if (this.cashIn && this.cashOut) {
        const cashInFields = [
          'order_success_amount',
          'piutang_amount',
          'topup_deposit_amount',
          'purchase_return_amount',
        ];

        const cashOutFields = [
          'order_canceled_amount',
          'incoming_stock_supplier_amount',
          'incoming_stock_warehouse_amount',
          'utang_amount',
          'withdraw_deposit_amount',
          'other_payment_amount',
          'cash_change',
          'order_return_amount'
        ]

        cashInFields.forEach(key => {
          if (key in this.cashIn) {
            this.cashIn[key] = format(this.cashIn[key]);
          }
        });

        cashOutFields.forEach(key => {
          if (key in this.cashOut) {
            this.cashOut[key] = format(this.cashOut[key]);
          }
        });
      }
    },
    getRupiah() {
      const rupiah = document.getElementById("v-amount");
      rupiah.value = this.formatRupiah(rupiah.value);
      this.formPayload.closing_cash = rupiah.value;
    },
    formatRupiah(angka, prefix) {
      let number_string = angka.replace(/[^,\d-]/g, "").toString();
      let isNegative = number_string.startsWith("-");
      if (isNegative) {
        number_string = number_string.substring(1);
      }
      const split = number_string.split(",");
      const sisa = split[0].length % 3;
      let rupiah = split[0].substr(0, sisa);
      const ribuan = split[0].substr(sisa).match(/\d{3}/gi);

      if (ribuan) {
        const separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }
      rupiah = split[1] != undefined ? `${rupiah},${split[1]}` : rupiah;
      return (
        (isNegative ? "-" : "") + (prefix == undefined ? rupiah : rupiah || "")
      );
    },
    formatToRupiah(amount) {
      const formatter = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      });
      return formatter.format(amount);
    },
    goToAdditionalCashDetail() {
      this.$bvModal.hide("modal-cash-report");
      this.isAdditionalCash = true;
      this.$bvModal.show("modal-cash-report");
    },
    goToListRetur() {
      this.$bvModal.hide("modal-cash-report");
      this.isReturList = true;
      this.$bvModal.show("modal-cash-report");
    },
    goToCanceledOrderList() {
      this.$bvModal.hide("modal-cash-report");
      this.isCanceledOrder = true;
      this.$bvModal.show("modal-cash-report");
    },
    goToCashChangeDetail() {
      this.$bvModal.hide("modal-cash-report");
      this.isCashChange = true;
      this.$bvModal.show("modal-cash-report");
    },
    goBack(name) {
      this.$bvModal.hide("modal-cash-report");
      if (name === "additional") {
        this.isAdditionalCash = false;
      } else if (name === "retur") {
        this.isReturList = false;
      } else if (name === "canceledOrder") {
        this.isCanceledOrder = false;
      } else {
        this.isCashChange = false;
      }
      this.$bvModal.show("modal-cash-report");
    },
    goToCashInDetail() {
      const openingTime = this.detailResult.opening_time;
      moment.locale("id");
      // const date = moment(openingTime, "dddd, DD MMMM YYYY HH.mm");
      const formattedDate = moment(openingTime).format("YYYY-MM-DD");

      const routeParams = {
        name: "transaction.index",
        query: { date: formattedDate },
      };
      const routePath = this.$router.resolve(routeParams).href;
      window.open(routePath, "_blank");
    },
    goToCashOutDetail() {
      const openingTime = this.detailResult.opening_time;
      moment.locale("id");
      // const date = moment(openingTime, "dddd, DD MMMM YYYY HH.mm");
      const formattedDate = moment(openingTime).format("YYYY-MM-DD");
      const routeParams = {
        name: "payout.index",
        query: { date: formattedDate },
      };
      const routePath = this.$router.resolve(routeParams).href;
      window.open(routePath, "_blank");
    },
    closeModal() {
      this.$bvModal.hide("modal-cash-report");
    },
    cleanUpForm() {
      this.formPayload.closing_cash = 0;
    },
    preparePayload() {
      const form = new FormData();
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.formPayload) {
        // eslint-disable-next-line no-prototype-builtins
        if (
          this.formPayload.hasOwnProperty(key) &&
          this.formPayload[key] != null
        ) {
          if (key === "closing_cash") {
            // eslint-disable-next-line radix
            form.append(
              key,
              parseFloat(this.preformatFloat(this.formPayload[key].toString()))
            );
          } else {
            form.append(key, this.formPayload[key]);
          }
        }
      }
      return form;
    },
    closeItem() {
      const form = this.preparePayload();
      this.isLoading = true;
      this.$store
        .dispatch("pettyCash/postClose", {
          query: "",
          payload: form,
          uuid: this.detailResultList.uuid,
        })
        .then(() => {
          this.getData();
          successNotification(this, "Success", "Kas Harian berhasil ditutup");
          this.cleanUpForm();
          this.$bvModal.hide("modal-cash-report");
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.data.meta.validations) {
            this.validations = error.response.data.meta.validations;
          }
          this.isLoading = false;
        });
    },
    updateFormattedDate() {
      const newDate = new Date();
      const momentDate = moment(newDate);
      const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu",
      ];
      const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];
      this.date = `${days[momentDate.day()]}, ${momentDate.format("DD")} ${months[momentDate.month()]
        } ${momentDate.format("YYYY HH:mm")}`;
    },
    goToCashInDetail() {
      const openingTime = this.detailResultList.opening_time;
      moment.locale("id");
      const date = moment(openingTime);
      const formattedDate = date.format("YYYY-MM-DD");
      const routeParams = {
        name: "transaction.index",
        query: { date: formattedDate },
      };
      const routePath = this.$router.resolve(routeParams).href;
      window.open(routePath, "_blank");
    },
    goToCashOutDetail() {
      const openingTime = this.detailResultList.opening_time;
      moment.locale("id");
      const date = moment(openingTime);
      const formattedDate = date.format("YYYY-MM-DD");
      const routeParams = {
        name: "payout.index",
        query: { date: formattedDate, payment_method: 'cash' },
      };
      const routePath = this.$router.resolve(routeParams).href;
      window.open(routePath, "_blank");
    },
    openCashModal(stateKey) {
      this.$bvModal.hide("modal-cash-report");
      // Reset all view flags
      this.isAdditionalCash = false;
      this.isReturList = false;
      this.isCanceledOrder = false;
      this.isCashChange = false;
      this.isReturSelling = false;
      this.isReturPurchasing = false;
      this.isPiutangPayments = false;
      this.isUtangPayments = false;
      this.isTopupDeposit = false;
      this.isWithdrawDeposit = false;

      // Set only the selected one to true
      if (stateKey && this.hasOwnProperty(stateKey)) {
        this[stateKey] = true;
      }

      this.$bvModal.show("modal-cash-report");
    },
    goBack(target) {
      this.$bvModal.hide("modal-cash-report");

      const resetMap = {
        additional: 'isAdditionalCash',
        retur: 'isReturList',
        retur_selling: 'isReturSelling',
        canceledOrder: 'isCanceledOrder',
        cash: 'isCashChange',
        retur_purchasing: 'isReturPurchasing',
        piutang_payments: 'isPiutangPayments',
        utang_payments: 'isUtangPayments',
        topup_deposit: 'isTopupDeposit',
        withdraw_deposit: 'isWithdrawDeposit',
      };

      const stateKey = resetMap[target];

      if (stateKey) {
        this[stateKey] = false;
      }

      this.$bvModal.show("modal-cash-report");
    },
    navigateWithCashAndDate(routeName) {
      const openingTime = this.detailResultList.opening_time;
      const uuid = this.detailResultList.uuid;
      moment.locale("id");
      const formattedDate = moment(openingTime).format("YYYY-MM-DD");
      const routeParams = {
        name: routeName,
        query: { payment_method: "cash", date: formattedDate, petty_cash_uuid: uuid }
      };
      const routePath = this.$router.resolve(routeParams).href;
      window.open(routePath, "_blank");
    },

    goToSellingDetail() {
      this.navigateWithCashAndDate("transaction.index");
    },
    
    goToStockLocationSku() {
      this.navigateWithCashAndDate("stock.gudang");
    },

    goToStockSupplier() {
      this.navigateWithCashAndDate("stock.supplier");
    },
    async exportToPDF() {
      try {
        this.isLoading = true;
        const modal = document.getElementById("modal-cash-report");
        modal.scrollTop = 0;
  
        const canvas = await html2canvas(modal, {
          scale: 1,
          useCORS: true,
          logging: false,
          scrollY: -window.scrollY,
          windowWidth: 872,
          windowHeight: modal.scrollHeight
        });
  
        const imgData = canvas.toDataURL("image/jpeg", 1);
        const pdf = new jsPDF({
          orientation: "p",
          unit: "px",
          format: [canvas.width, canvas.height] // match PDF size to modal size
        });

        
        pdf.addImage(imgData, "JPEG", 0, 0, canvas.width, canvas.height);
        pdf.save(`Kas-Harian-${moment().format("DDMMYY")}.pdf`);
  
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    }
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";

.button__group {
  display: flex;
  width: 100%;
  justify-content: end;

  .button__cancel {
    background-color: #ffffff !important;
    border-color: $light--3 !important;
    color: $dark !important;
  }

  .button__save {
    background-color: #45b6ab !important;
    border-color: #45b6ab !important;
  }
}

.custom__input--product {
  height: 79px !important;
}
</style>
